import script from "./RacingPageFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./RacingPageFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./RacingPageFixtureBook.vue?vue&type=style&index=0&id=d05e4030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d05e4030"]])

export default __exports__